import React from "react"

import { graphql } from "gatsby"
import { useTranslation } from "@zestia/gatsby-plugin-react-i18next"

import SharedHead from "@/components/SharedHead"
import useHeadTranslation from "@/hooks/use-head-translation"

import SupportTopicLandingLayout from "@/layouts/SupportTopicLanding"

export const Head = props => {
  const { t } = useHeadTranslation(props)

  return (
    <SharedHead
      {...props}
      title={t("support.topic.importing-and-migrating-data.name")}
      description={t(
        "support.topic.importing-and-migrating-data.meta-description",
      )}
    />
  )
}

const SupportImportingAndMigratingDataLandingPage = ({ data }) => {
  const { t } = useTranslation()

  return (
    <SupportTopicLandingLayout
      title={t("support.topic.importing-and-migrating-data.name")}
      articles={data.allSanitySupportDoc.nodes}
    />
  )
}

export const query = graphql`
  query ($language: String) {
    ...Locales

    allSanitySupportDoc(
      filter: {
        hidden: { ne: true }
        language: { eq: $language }
        topic: { eq: "importing-and-migrating-data" }
      }
    ) {
      nodes {
        _rawContent
        title
        slug {
          current
        }
        sortOrder
        isNew
      }
    }
  }
`

export default SupportImportingAndMigratingDataLandingPage
